import { render, staticRenderFns } from "./ReponseResidentsFeedbackModal.vue?vue&type=template&id=2b2b03af&scoped=true&"
import script from "./ReponseResidentsFeedbackModal.vue?vue&type=script&lang=js&"
export * from "./ReponseResidentsFeedbackModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2b03af",
  null
  
)

export default component.exports